// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.imght[data-v-01651fa2] {\n  height: 100px;\n}\n.misInfo[data-v-01651fa2] {\n  font-weight: 300;\n  background-image: linear-gradient(to right, rgb(218 189 189 / 0%), rgb(151 172 230 / 44%));\n  box-shadow: rgba(18, 18, 18, 0.11) 0px 0px 0px 0px, rgba(18, 18, 18, 0.10) 0px 2px 2px 0px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
